export default __webpack_public_path__ + "static/media/office-cmc.a1fb741f.jpg";